/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const teamPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const teamPageResponseOutputItemsItemNameMax = 100;

export const teamPageResponseOutputItemsItemDescriptionOneMax = 2000;

export const teamPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const teamPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const teamPageResponseOutputItemsItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const teamPageResponseOutputItemsItemUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const teamPageResponseOutputNextCursorOneMax = 512;

export const teamPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const TeamPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(teamPageResponseOutputItemsItemIdRegExp),
      name: zod.string().min(1).max(teamPageResponseOutputItemsItemNameMax),
      description: zod.union([
        zod.string().max(teamPageResponseOutputItemsItemDescriptionOneMax),
        zod.null(),
      ]),
      active: zod.boolean(),
      version: zod
        .int()
        .gt(teamPageResponseOutputItemsItemVersionExclusiveMin)
        .max(teamPageResponseOutputItemsItemVersionMax),
      createdAt: zod.iso
        .datetime({ offset: true })
        .regex(teamPageResponseOutputItemsItemCreatedAtRegExp),
      updatedAt: zod.iso
        .datetime({ offset: true })
        .regex(teamPageResponseOutputItemsItemUpdatedAtRegExp),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(teamPageResponseOutputNextCursorOneMax)
      .regex(teamPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type TeamPageResponseOutput = zod.input<typeof TeamPageResponseOutput>;
export type TeamPageResponseOutputOutput = zod.output<typeof TeamPageResponseOutput>;
